webpackJsonp([260492025453540],{

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRouter = __webpack_require__(15);
	
	var _reactCustomScrollbars = __webpack_require__(58);
	
	var _reactHelmet = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CommunityRulesPage = function (_React$Component) {
	  _inherits(CommunityRulesPage, _React$Component);
	
	  function CommunityRulesPage() {
	    _classCallCheck(this, CommunityRulesPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CommunityRulesPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { id: 'community-rules', className: 'page community-rules' },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Community Rules'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'ParkYou! unites micro-communities of city car owners to instantaneously find street parking. We are launching in Fall 2018. Read our community rules here.' })
	      ),
	      _react2.default.createElement(
	        _reactCustomScrollbars.Scrollbars,
	        { className: 'article' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Community Rules'
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginTop: "10px" } },
	          'The ParkYou! community rules are below. Parky says if we all follow them everyone will have an awesome parking experience.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Find a Spot Rules'
	        ),
	        _react2.default.createElement(
	          'ol',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'You may cancel a search at any time before accepting a spot. Once you have accepted a spot, however, you must take it, even if you see an empty spot beforehand.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Make sure you press the \u201CAccept\u201D button within the 25 second time limit when a spot is offered to you.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Do not rush to get to your spot. And slow down as you get close. Stay safe and look out for your parking partner.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'The \u201CArrived\u201D button will become pressable shortly before you actually arrive. Do not press it until you are within 75 feet of the parking spot.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'When you arrive, pull up to your benefactor and smile and wave. They\u2019re a great neighbor. Once they see you, back up so they can pull out.'
	          )
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Offer a Spot Rules'
	        ),
	        _react2.default.createElement(
	          'ol',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Only offer your spot once you have arrived at your vehicle.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Only offer free spots in primarily residential areas when there is no alternate side parking requirement until at least the next day.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Never offer a free spot in primarily commercial areas unless the spot is available for at least two hours.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'You may cancel your offer at any time before your offered spot is accepted, but once it is accepted, you must wait for your parking partner to arrive.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Don\u2019t turn your lights or blinker on until you receive a notification that your parking partner is close.'
	          )
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Guidelines for Interacting with Non-ParkYou! Members While Waiting'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If, while waiting for someone to select your spot or for your parking partner to arrive, another driver asks you for the spot, tell them \u201CI\u2019m not leaving.\u201D Most people will drive away. If they are insistent, explain to them that a neighbor is coming to take the spot in a few minutes. If they have further questions, it may be an excellent opportunity to invite them to join the ParkYou! Community. Please use your judgment.'
	        )
	      )
	    );
	  };
	
	  return CommunityRulesPage;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouter.withRouter)(CommunityRulesPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-community-rules-js-c3c35b89882de48ccce2.js